export const INDEX_LOCALES = [
    '/at/de',
    '/at/en',
    '/be/nl',
    '/be/fr',
    '/be/de',
    '/be/en',
    '/bg/bg',
    '/bg/en',
    '/ch/de',
    '/ch/fr',
    '/ch/it',
    '/ch/en',
    '/cz/cs',
    '/cz/en',
    '/de/de',
    '/de/en',
    '/dk/da',
    '/dk/en',
    '/ee/en',
    '/es/es',
    '/es/en',
    '/fi/fi',
    '/fi/sv',
    '/fi/en',
    '/fr/fr',
    '/fr/en',
    '/gb/en',
    '/hr/hr',
    '/hr/en',
    '/hu/hu',
    '/hu/en',
    '/ie/en',
    '/is/en',
    '/it/it',
    '/it/en',
    '/lt/en',
    '/lt/lt',
    '/lu/fr',
    '/lu/de',
    '/lu/en',
    '/lv/en',
    '/lv/lv',
    '/nl/nl',
    '/nl/en',
    '/no/no',
    '/no/en',
    '/pl/pl',
    '/pl/en',
    '/ro/ro',
    '/ro/en',
    '/se/sv',
    '/se/en',
    '/si/sl',
    '/si/en',
    '/sk/sk',
    '/sk/en',
    '/ge/en',
    '/xi/en',
    '/xu/ru',
    '/xu/en',
    '/tm/ru',
    '/tm/en',
    '/cq/ru',
    '/cq/en',
    '/am/ru',
    '/am/en',
    '/az/ru',
    '/az/en',
    '/kg/ru',
    '/kg/en',
    '/kz/ru',
    '/kz/en',
    '/tj/ru',
    '/tj/en',
    '/uz/ru',
    '/uz/en',
];
